module.exports = __webpack_public_path__ + "img/copy.bda9c4f9.svg";